var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderMilestonesi = function SvgLegendBuilderMilestonesi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 11.2V9.218a.79.79 0 0 0-.837-.782h-1.628V7.7a.93.93 0 0 0 .512-.78.86.86 0 0 0-.884-.92H8.791a.88.88 0 0 0-.884.874.8.8 0 0 0 .512.782v.782H6.837A.82.82 0 0 0 6 9.22v1.929a1.82 1.82 0 0 0 .791 1.471 1.9 1.9 0 0 0 1.023.322h1.628l.14.138a4.4 4.4 0 0 0 1.627.92v2.161h-.465a.92.92 0 1 0 0 1.839H13.3a.89.89 0 0 0 .884-.92.92.92 0 0 0-.884-.92h-.465V14a3.55 3.55 0 0 0 1.674-.92l.14-.138h1.628a1.9 1.9 0 0 0 1.023-.321A1.78 1.78 0 0 0 18 11.2m-10.558 0V9.954h.93v.6a3.2 3.2 0 0 0 .14.92h-.791a.3.3 0 0 1-.279-.274m9.07 0a.3.3 0 0 1-.279.276h-.791a3 3 0 0 0 .14-.92v-.6h.93z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderMilestonesi);
export default ForwardRef;